import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

import { PortInvoiceBaseDto } from '../invoice';
import { InvoiceService } from '../invoice.service';

@Component({
  selector: 'app-invoice-detail',
  standalone: false,
  templateUrl: './invoice-detail.component.html',
  styleUrls: ['./invoice-detail.component.css']
})
export class InvoiceDetailComponent implements OnInit {
  portInvoiceBaseDto: PortInvoiceBaseDto | undefined;

  constructor(
    private route: ActivatedRoute,
    private invoiceService: InvoiceService,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.getInvoice();
  }

  getInvoice(): void {
    const portId = Number(this.route.snapshot.paramMap.get('portId'));
    const id = Number(this.route.snapshot.paramMap.get('id'));
    this.invoiceService
      .getInvoice(portId, id)
      .subscribe((invoice) => (this.portInvoiceBaseDto = invoice));
  }

  goBack(): void {
    this.location.back();
  }
}
